import type { RouteRecordRaw } from 'vue-router';
import { useAdminNavStore } from '@/modules/admin/stores/admin-nav';
import { navItems } from './nav';

const setNavItems = () => {
  const store = useAdminNavStore();
  store.navItems = navItems;
};

export const adminExpertCommentaryRoute: RouteRecordRaw = {
  path: `/admin/expert-commentary`,
  name: 'adminExpertCommentary',
  component: () => import('@/modules/admin-expert-commentary/views/ExpertCommentaryAdmin.vue'),
  beforeEnter: () => {
    setNavItems();
  },
  meta: {
    layout: 'admin-sidebar',
  },
};
